import React from 'react';
import { replaceTemplateValues, type TermsTemplateValues } from './termsTemplate';

export type PublicTermsPageData = {
  title?: string;
  content?: string;
  values?: TermsTemplateValues;
  errorLabel?: string;
};

type Props = {
  data: PublicTermsPageData;
};

export function PublicTermsPage({ data }: Props) {
  if (!data) {
    return null;
  }

  const { title, content, values, errorLabel } = data;
  const resolvedContent = replaceTemplateValues(content, values).trim();

  return (
    <div className="public-terms-page">
      {title ? <h1 className="public-terms-page__title">{title}</h1> : null}

      {resolvedContent ? (
        <div
          className="public-terms-page__content"
          dangerouslySetInnerHTML={{ __html: resolvedContent }}
        />
      ) : (
        errorLabel && (
          <p className="public-terms-page__error" role="alert">
            {errorLabel}
          </p>
        )
      )}
    </div>
  );
}
